import { useNavigate } from 'react-router-dom'
import { Layer } from 'components'
import styles from 'views/setting/index.module.css'
import CertListLayer from 'views/setting/cert/CertListLayer'
import ChangePasswordLayer from 'views/setting/cert/ChangePasswordLayer'
import { showCertLayerState, showCertListLayerState, showChangePasswordLayerState } from 'views/setting/cert/states'
import { useRecoilState } from 'recoil'
import { useEffect, useState } from 'react'
import Lib from 'library'
import Native from 'library/native'
import useApp from 'hooks/useApp'
import Switch2 from '../../../components/Switch2'

const CertiLayer = () => {

	const App = useApp()
	const [showCertLayer, setShowCertLayer] = useRecoilState(showCertLayerState)
	const [showCertListLayer, setShowCertListLayer] = useRecoilState(showCertListLayerState)
	const [showChangePasswordLayer, setShowChangePasswordLayer] = useRecoilState(showChangePasswordLayerState)
	const [useBio, setUseBio] = useState()
	const navigate = useNavigate()

	const bioInit = t => {

		Lib.post("/api/more/myinfo/upd/bio", {
			bioAuthUseYn: t ? "Y" : "N"
		}, data => {
			if (data) {
				window.localStorage.setItem("useBio", t)
				setUseBio(t);
			}
		})
	}

	const doIt = () => {
		console.log(useBio);
		console.log("useBio 있나? ", !useBio);
		if (!useBio) {
			console.log("Bio ==> setAuthenticate 들어가기 전");
			Native.execute("AppManager", "setAuthenticate", result => {
				console.log("Bio ==> setAuthenticate");
				const json = JSON.parse(result)

				if (json.result === "Success") {
					bioInit(!useBio)
				} else {
					console.error(decodeURI(json.result))
				}
			}, { userid: App.user.mbId })
		} else {
			bioInit(!useBio)
		}

/*
		Lib.post("/api/more/myinfo/upd/bio", {
			bioAuthUseYn: t ? "Y" : "N"
		}, data => {
			console.log('t : ' + t);
			console.log('data : ' + data);
			console.log('useBio : ' + window.localStorage.getItem("useBio"));

			if (data) {
				window.localStorage.setItem("useBio", t)
			}	
			if (t && data) {
				Native.execute("AppManager", "setAuthenticate", result => {
					console.log('result : ' + result)
					const json = JSON.parse(result)
					if (json.result !== "Success") {
						console.error(decodeURI(json.result))
					}
				}, { userid: App.user.mbId })				
			}
		})
*/
	}

	useEffect(() => {
		if(showCertLayer=== true){
			Lib.get("/api/more/myinfo", data => {
				setUseBio(data.bioAuthUseYn === "Y" ? true : false)
			})
		}
	}, [showCertLayer])

	return (
		<Layer show={showCertLayer} closeLayer={() => setShowCertLayer(false)}>
			<div className="page">
				<div className="padding">
					<div className={styles.title}>인증/보안</div>
					<ul className={`${styles["link-menu"]} mt_40`}>
						<li>
							{/* <span className={styles.linkSpan} onClick={() => setShowChangePasswordLayer(true)}> */}
							<span className={styles.linkSpan} onClick={() => {
								App.closeAllLayers()
								navigate("/changePassword")
							}}>
								<p>간편비밀번호 변경</p>
								<i className="icon icon_arrow_sm right" />
							</span>
						</li>
						<li>
							<div className="flex-justify_between align_center">
								<p>생체인증 서비스 이용</p>
								<Switch2 on={useBio} onToggle={doIt} />
							</div>
						</li>
						<li>
							<span className={styles.linkSpan} onClick={() => setShowCertListLayer(true)}>
								<p>인증서관리</p>
								<i className="icon icon_arrow_sm right" />
							</span>
						</li>
					</ul>
				</div>
			</div>

			<CertListLayer show={showCertListLayer} closeLayer={() => setShowCertListLayer(false)} />
			<ChangePasswordLayer show={showChangePasswordLayer} closeLayer={() => setShowChangePasswordLayer(false)} />

		</Layer>
	)
}

export default CertiLayer